const filterConfig = {
  type: 'object',
  properties: {      
      search: {
          type: 'string',
      },
    }
}
const getProducerFiltersConfig: any = (user: any) => {
  return filterConfig;
}
export default getProducerFiltersConfig;